module.exports = __webpack_public_path__ + "static/media/arrow-ddl-light.e2f04a64.svg";